import { render, staticRenderFns } from "./karobka.vue?vue&type=template&id=6ce7dbda&scoped=true&"
import script from "./karobka.vue?vue&type=script&lang=js&"
export * from "./karobka.vue?vue&type=script&lang=js&"
import style0 from "./karobka.vue?vue&type=style&index=0&id=6ce7dbda&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ce7dbda",
  null
  
)

export default component.exports